import actionTypes from "actions/types/webActionTypes";

/*==========================
    Reducers
==========================*/
const reducers = {
	// 紀錄每個列表最後scroll到的位置(position)
	[actionTypes.storeScrollPosition]: function(state, action) {
		return storeScrollPosition(state, action);
	},
	// 紀錄每個列表最後scroll到的位置(index)
	[actionTypes.storeRenderedIndex]: function(state, action) {
		return storeRenderedIndex(state, action);
	},
	// 開啟確認Dialog
	[actionTypes.openConfirmDialog]: function(state, action) {
		return openConfirmDialog(state, action);
	},
	// 關閉確認Dialog
	[actionTypes.closeConfirmDialog]: function(state, action) {
		return closeConfirmDialog(state, action);
	},
	// 開啟提示視窗
	[actionTypes.openAlertDialog]: function(state, action) {
		return openAlertDialog(state, action);
	},
	// 關閉提示視窗
	[actionTypes.closeAlertDialog]: function(state, action) {
		return closeAlertDialog(state, action);
	},
	// 開啟發票明細視窗
	[actionTypes.openInvoiceDetailDialog]: function(state, action) {
		return openInvoiceDetailDialog(state, action);
	},
	// 關閉發票明細視窗
	[actionTypes.closeInvoiceDetailDialog]: function(state, action) {
		return closeInvoiceDetailDialog(state, action);
	},
	// 成功取得web各種狀態 (金流開啟狀態與mobile是否維修)
	[actionTypes.checkWebStateSuccess]: function (state, action) {
		return checkWebStateSuccess(state, action);
	},
	[actionTypes.openBuyBonusPdtDialog]: (state, action) => openBuyBonusPdtDialog(state, action),
	[actionTypes.closeBuyBonusPdtDialog]: (state, action) => closeBuyBonusPdtDialog(state, action),
	[actionTypes.showSimpleAlertDialog]: (state, action) => showSimpleAlertDialog(state, action),
	[actionTypes.setPlatform]: (state, action) => setPlatform(state, action),
};

/*==========================
    Method
==========================*/

// ------------------------------
// 紀錄每個列表最後scroll到的位置(position)
// ------------------------------
function storeScrollPosition (state, action) {

	if (state.scrollPosition[action.payload.key] === action.payload.scrollTop) {
		return state;
	}

	const newScrollPosition = Object.assign({}, state.scrollPosition, {
		[action.payload.key]: action.payload.scrollTop
	});

	return Object.assign({}, state, {
		scrollPosition: newScrollPosition
	});
}

// ------------------------------
// 紀錄每個列表最後scroll到的位置(index)
// ------------------------------
function storeRenderedIndex (state, action) {
	
	if (state.renderedIndex[action.payload.key] === action.payload.event) {
		return state;
	}

	const newRenderedIndex = Object.assign({}, state.renderedIndex, {
		[action.payload.key]: action.payload.event
	});

	return Object.assign({}, state, {
		renderedIndex: newRenderedIndex
	});
}

// ------------------------------
// 開啟確認Dialog
// ------------------------------
function openConfirmDialog(state, action) {
	// debugger
	var confirmDialog = state.confirmDialog;

	if(confirmDialog.isOpen) {
		return state;
	}

	const payload = action.payload;

	var new_confirmDialog = Object.assign({}, confirmDialog, {
		isOpen: true,
		title: payload.title || undefined,
		description: payload.description || undefined,
		isPromise: payload.isPromise,
		confirmCallback: payload.confirmCallback || undefined,
		confirmPromise: payload.confirmPromise || undefined,
		cancelCallback: payload.cancelCallback || undefined,
		closeCallback: payload.closeCallback || undefined,
		confirmName: payload.confirmName || undefined,
		cancelName: payload.cancelName || undefined,
	});

    return Object.assign({}, state, {
        confirmDialog: new_confirmDialog,
    });
}

// ------------------------------
// 關閉確認Dialog
// ------------------------------
function closeConfirmDialog(state, action) {

	var confirmDialog = state.confirmDialog;

	if(!confirmDialog.isOpen) {
		return state;
	}

    var new_confirmDialog = Object.assign({}, confirmDialog, {
		isOpen: false,
		title: undefined,
		description: undefined,
		isPromise: false,
		confirmCallback: undefined,
		confirmPromise: undefined,
		cancelCallback: undefined,
		confirmName: undefined,
		cancelName: undefined,
	});

    return Object.assign({}, state, {
        confirmDialog: new_confirmDialog,
    });
}

// ------------------------------
// 開啟提示視窗
// ------------------------------
function openAlertDialog(state, action) {
	
	var alertDialog = state.alertDialog;

	if(alertDialog.isOpen) {
		return state;
	}

	const payload = action.payload;

	var new_alertDialog = Object.assign({}, alertDialog, {
		isOpen: true,
		title: payload.title || undefined,
		description: payload.description || undefined,
		renderDescription: payload.renderDescription || undefined,
		imageUrl: payload.imageUrl || undefined,
		closeName: payload.closeName || undefined,
		closeCallback: payload.closeCallback || undefined,
	});

    return Object.assign({}, state, {
        alertDialog: new_alertDialog,
    });
}

// ------------------------------
// 關閉提示視窗
// ------------------------------
function closeAlertDialog(state, action) {

	var alertDialog = state.alertDialog;

	if(!alertDialog.isOpen) {
		return state;
	}

    var new_alertDialog = Object.assign({}, alertDialog, {
		isOpen: false,
		title: undefined,
		description: undefined,
		closeName: undefined,
		closeCallback: undefined,
	});

    return Object.assign({}, state, {
        alertDialog: new_alertDialog,
    });
}



// ------------------------------
// 開啟提示視窗
// ------------------------------
function openInvoiceDetailDialog(state, action) {

	var invoiceDetailDialog = state.invoiceDetailDialog;
	if(invoiceDetailDialog.isOpen) {
		return state;
	}
	const payload = action.payload;
	var new_invoiceDetailDialog = Object.assign({}, invoiceDetailDialog, {
		isOpen: true,
		invoiceDetail : payload.invoiceDetail || undefined,
		closeName: payload.closeName || undefined,
		closeCallback: payload.closeCallback || undefined,
	});
	
    return Object.assign({}, state, {
        invoiceDetailDialog: new_invoiceDetailDialog,
    });
}

// ------------------------------
// 關閉提示視窗
// ------------------------------
function closeInvoiceDetailDialog(state, action) {

	var invoiceDetailDialog = state.invoiceDetailDialog;

	if(!invoiceDetailDialog.isOpen) {
		return state;
	}

    var new_invoiceDetailDialog = Object.assign({}, invoiceDetailDialog, {
		isOpen: false,
		invoiceDetail: undefined,
		closeName: undefined,
		closeCallback: undefined,
	});

    return Object.assign({}, state, {
        invoiceDetailDialog: new_invoiceDetailDialog,
    });
}

function checkWebStateSuccess(state, { payload }) {

	const { result = {} } = payload;
	const newState = Object.assign({}, state, result);

	return newState;
}

function openBuyBonusPdtDialog(state, { payload }) {
	
	if (state.buyBonusPdtDialog.isOpen) {
		return state;
	}

	return {
		...state,
		buyBonusPdtDialog: {
			isOpen: true,
			productid: payload.productid,
			jsdproductid: payload.jsdproductid,
		},
	};
}

function closeBuyBonusPdtDialog(state) {
	
	if (!state.buyBonusPdtDialog.isOpen) {
		return state;
	}

	return {
		...state,
		buyBonusPdtDialog: {
			isOpen: false,
			productid: null,
			jsdproductid: null,
		},
	};
}

function showSimpleAlertDialog(state, { payload }) {
	return {
		...state,
		simpleAlertDialog: {
			timestamp: Date.now(),
			text: payload.text,
		},
	};
}

function setPlatform(state, { payload }) {

	const {
		platform,
	} = payload;

	if (!platform) {
		return state;
	}

	return {
		...state,
		platform,
	};
}

/*==========================
    Export
==========================*/
export default function createReducers (initialState) {
	return function reducer(state = initialState, action) {
		if(!actionTypes.hasOwnProperty(action.type)){
            return state;
        }
		if (reducers.hasOwnProperty(action.type)) {
			return reducers[action.type](state, action);
		} else {
			return state;
		}
	};
}